import { alpha, type SxProps, type Theme } from '@mui/material';

export const historyIconButtonSx: SxProps<Theme> = (theme) => ({
  width: '1.5rem',
  height: '1.5rem',
  borderRadius: '0.375rem',
  color: theme.palette.custom.OV.sys.onSurfaceVariant,
  '& .MuiSvgIcon-root': { fontSize: '0.9375rem', display: 'block' },
  // an inline <svg> adds a baseline gap that pushes the circle off centre
  '& .MuiCircularProgress-svg': { display: 'block' },
  '&:hover': {
    backgroundColor: theme.palette.custom.OV.sys.surfaceContainerHigh,
    color: theme.palette.custom.OV.sys.onBackground,
  },
});

export const getChatInputContainerSx =
  (isInputFocused: boolean): SxProps<Theme> =>
  (theme) => ({
    margin: '0.5rem 0 0',
    padding: '0.5rem 0.5rem 0.5rem 0.75rem',
    backgroundColor: alpha(theme.palette.custom.OV.sys.surfaceContainer, 0.6),
    backdropFilter: 'blur(14px) saturate(1.4)',
    WebkitBackdropFilter: 'blur(14px) saturate(1.4)',
    border: `1px solid ${
      isInputFocused
        ? theme.palette.custom.OV.sys.secondary
        : alpha(theme.palette.custom.OV.sys.outlineVariant, 0.8)
    }`,
    borderRadius: '0.75rem',
    boxShadow: theme.shadows[8],
    transition: 'border-color 120ms ease',
  });

export const chatInputSx: SxProps<Theme> = (theme) => ({
  width: '100%',
  display: 'block',
  padding: '0.125rem 0.125rem 0.5rem',
  fontSize: '0.78125rem',
  lineHeight: 1.5,
  color: theme.palette.custom.OV.sys.onBackground,
  '& .MuiInputBase-input': { padding: 0 },
  '& .MuiInputBase-input::placeholder': {
    color: theme.palette.custom.OV.sys.onSurfaceVariant,
    opacity: 1,
  },
});

export const conversationContextSx: SxProps<Theme> = (theme) => ({
  height: '1.75rem',
  px: 1,
  flex: '0 1 auto',
  minWidth: 0,
  borderRadius: '0.5rem',
  color: theme.palette.custom.OV.sys.onSurfaceVariant,
});

export const getSendButtonSx =
  (canSend: boolean): SxProps<Theme> =>
  (theme) => ({
    width: '1.75rem',
    height: '1.75rem',
    // the default IconButton padding leaves a 10px content box; both spill out
    padding: 0,
    display: 'grid',
    placeItems: 'center',
    borderRadius: '50%',
    flexShrink: 0,
    backgroundColor: theme.palette.custom.OV.sys.surfaceContainerHighest,
    border: `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,
    color: theme.palette.custom.OV.sys.onSurfaceVariant,
    transition: 'background-color .12s, color .12s, border-color .12s',
    '& .MuiSvgIcon-root': { fontSize: '0.9375rem', display: 'block' },
    // an inline <svg> adds a baseline gap that pushes the circle off centre
    '& .MuiCircularProgress-svg': { display: 'block' },
    '&:hover': canSend
      ? {
          backgroundColor: theme.palette.custom.OV.sys.secondary,
          borderColor: theme.palette.custom.OV.sys.secondary,
          color: theme.palette.custom.OV.sys.onSecondary,
        }
      : undefined,
    '&.Mui-disabled': {
      color: theme.palette.custom.OV.sys.onSurfaceVariant,
      opacity: 0.5,
    },
  });
